// Sprint V102.ab · v2.1 (03.10.2026) — QuickCheck v2 vollstaendig homogenisiert
// Alle 5 Items nutzen dieselbe 1-5-Likert-UI. Spiegelt
// /app/backend/content/quickcheck_v102.py.

export const LIKERT_OPTIONS_V102 = [
  { value: 1, label: "Stimmt gar nicht" },
  { value: 2, label: "Eher nein" },
  { value: 3, label: "Teils/teils" },
  { value: 4, label: "Ziemlich genau" },
  { value: 5, label: "Trifft mich zu 100 %" },
];

export const QUICKCHECK_V102 = [
  {
    qid: 1,
    kind: "likert",
    measures: "katze",
    text:
      "Wenn mir jemand ungefragt sagt: „Du musst das jetzt genau so machen!“, spüre ich sofort einen inneren Widerstand und mache es oft schon aus Prinzip anders oder gar nicht.",
  },
  {
    qid: 2,
    kind: "likert",
    measures: "eule",
    text:
      "Ich kann eine Anweisung oder Bitte innerlich erst annehmen, wenn ich den logischen Sinn dahinter verstehe. Antworten wie „Das machen wir schon immer so“ machen mich innerlich fassungslos.",
  },
  {
    qid: 3,
    kind: "likert",
    measures: "biene",
    text:
      "Wenn Dinge nur halbherzig oder schlampig erledigt werden („Passt schon!“), juckt es mich in den Fingern — ich mache es am Ende lieber gleich selbst richtig, bevor es fehlerhaft bleibt.",
  },
  {
    qid: 4,
    kind: "likert",
    measures: "hund",
    text:
      "Wenn die Stimmung kippt oder jemand einsilbig wird, frage ich mich reflexartig: „Was habe ICH gerade falsch gemacht?“ — und überlege krampfhaft, wie ich die Verbindung wieder reparieren kann.",
  },
  {
    // Q5 ist jetzt eine homogene Likert-Statement-Frage, Scoring passiert
    // im Backend ueber die Achsen-Matrix (Sache vs. Mensch).
    qid: 5,
    kind: "likert",
    measures: "axis",
    text:
      "In hitzigen Diskussionen ist mir ein sachlich korrektes Ergebnis am Ende wichtiger, als dass sich alle Beteiligten im Raum wohlfühlen.",
  },
];
